<template>
	<ul class="nav nav-tabs nav-tabs-flush gap-5 mt-1 mt-md-0 overflow-x border-0">
		<li class="nav-item" v-for="(name, index) in options" v-bind:key="index">
			<a href="javascript:void(0);" class="nav-link" :class="{ 'active': (index == selected) }" @click="selected = index;">{{ name }}</a>
		</li>
	</ul>
</template>

<script>
	import { ref, onMounted } from 'vue';
	import _ from 'lodash';

	export default {
		props: {
			options: Object
		},
		setup(props) {
			const selected = ref(null);

			onMounted(() => {
				selected.value = _.keys(props.options)[0];
			});

			return { selected };
		}
	}
</script>